module.exports = __webpack_public_path__ + "static/img/flow.3af8fb0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/flow.png
// module id = 2SpX
// module chunks = 0